import * as React from "react";
const SvgModeGoodsIn20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M2 1H1v14h2.464l2-2H3V9h14v4h-2.464l2 2H19V1H2Zm15 6V3h-6v4h6ZM9 7V3H3v4h6Zm1 3.586.707.707 3.5 3.5-1.414 1.414L11 14.414V20H9v-5.586l-1.793 1.793-1.414-1.414 3.5-3.5.707-.707Z",
      clipRule: "evenodd"
    })
  );
export default SvgModeGoodsIn20Px;
